import { useGetAllDocumentsQuery } from '@entities/common/commonQueries/index.ts';
import cn from 'classnames';
import { memo } from 'react';
import { Link } from 'react-router-dom';
import * as st from './styles.module.scss';

export const Footer = memo(() => {
  const { data: documents } = useGetAllDocumentsQuery(undefined);
  const date = new Date();
  const firmName = `© ${date.getFullYear()} LEO TRADO DEVELOPMENT`;

  return (
    documents && (
      <footer className={st.footer}>
        <section className={cn(st.innerWrapper, !documents.footer.length && st.withoutDocuments)}>
          <p className={st.activeFields}>
            {documents.footer.map((el) => (
              <Link to={`${el.id}`} key={el.id}>
                {el.name}
              </Link>
            ))}
          </p>
          <Link to={`https://leotrado.com/`} target="_blank" className={st.name}>
            {firmName}
          </Link>
        </section>
      </footer>
    )
  );
});
